import subAccountLogPart from '@/page/accountManagement/child/config/part/subAccountLog';

export const main = [
  {
    name: '子账号操作日志',
    childMenu: [subAccountLogPart]
  }
];
